module.exports = __webpack_public_path__ + "static/house-demolition-single-1e78c741eb79c02bf94c26dd516df2eb.jpg";